/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId/cart/success/:key' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../../../CacheDataRoute';
import BarMenuOrder from '@routes/BarMenu/stages/BarMenuOrder';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/cart/success/$key')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId/cart/success/:key',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenuOrder} path='/bar-menu/:barId/:tableId/cart/success/:key' />
  )
});
